import React, { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';
import { cn } from '@bem-react/classname';
import { fetchChangeGroups } from 'store/action/groups';

import { Button, Input, Title } from 'components';

import './ChangeGroup.scss';

const CnChangeGroup = cn('changeGroup');

export const ChangeGroup: React.FC = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const state = location.state as {
        name: string;
        id: string;
    };

    const dispatch = useDispatch();

    const [name, setName] = useState(state.name);

    const [errors, setErrors] = useState<Array<'name'>>([]);

    const nameChangeCallback = useCallback(
        (e: React.ChangeEvent<HTMLInputElement>) => {
            if (errors.includes('name')) {
                setErrors((prev) => prev.filter((err) => err !== 'name'));
            }
            setName(e.target.value);
        },
        [errors],
    );

    const submitClickHandler = () => {
        const newErrors: Array<'name'> = [];

        if (!name) {
            newErrors.push('name');
        }

        if (!newErrors.length) {
            navigate(location.pathname);
            dispatch(
                fetchChangeGroups({
                    name,
                    templateGroupId: state.id,
                }),
            );
        } else {
            setErrors(newErrors);
        }
    };

    return (
        <div className={CnChangeGroup()}>
            <div className={CnChangeGroup('header')}>
                <Title size="xs">Изменить группу</Title>
            </div>

            <div className={CnChangeGroup('form')}>
                <Input
                    isInvalid={errors.includes('name')}
                    value={name}
                    onChange={nameChangeCallback}
                    label="Название"
                    invalidMessage="Обязательное поле"
                    placeholder=""
                />
            </div>

            <div className={CnChangeGroup('actions')}>
                <Button onClick={submitClickHandler} view="primary" size="m">
                    Изменить
                </Button>
            </div>
        </div>
    );
};
